import Vue from "vue";
import Vuex from "vuex";
import ApiService from "./services/api.service";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    articleNumber: null,
    products: [],
    showLoadingScreen: false,
    hideArticleSearchForm: false,
    selectedRoom: {}
  },
  mutations: {
    SET_ARTICLE_NUMBER(state, newNumber) {
      Vue.set(state, "articleNumber", newNumber);
    },
    SET_ROOM(state, room) {
      Vue.set(state, "selectedRoom", room);
    },
    FETCH_PRODUCTS(state, products) {
      Vue.set(state, "products", products);
    },
    SET_LOADING_SCREEN(state, loadingState) {
      Vue.set(state, "showLoadingScreen", loadingState);
    },
    SET_HIDE_ARTICLESEARCH(state, visibilityState) {
      Vue.set(state, "hideArticleSearchForm", visibilityState);
    }
  },
  actions: {
    setArticleNumber(context, articleNumber) {
      context.commit("SET_ARTICLE_NUMBER", articleNumber);
    },
    setRoomType(context, room) {
      context.commit("SET_ROOM", room);
    },
    hideArticleSearch({ commit }) {
      commit("SET_HIDE_ARTICLESEARCH", true);
    },
    fetchProducts({ commit }) {
      return new Promise((resolve, reject) => {
        ApiService.getProducts()
          .then(response => {
            let products = Object.freeze(response.data); //avoids vuejs adding reactivity to the array entries aka products
            commit("FETCH_PRODUCTS", products);
            // console.log("FETCH_PRODUCTS", response, products);
            resolve();
          })
          .catch(error => {
            console.error("FETCH_PRODUCTS -> error", error.statusText);
            reject();
          });
      });
    },
    showLoadingScreen({ commit }) {
      commit("SET_LOADING_SCREEN", true);
    },
    hideLoadingScreen({ commit }) {
      commit("SET_LOADING_SCREEN", false);
    }
  },
  getters: {
    getArticleNumber(state) {
      return state.articleNumber;
    },
    getProducts(state) {
      return state.products;
    },
    getLoadingScreenState(state) {
      return state.loadingState;
    },
    getArticleSearchFormVisibility(state) {
      return state.hideArticleSearchForm;
    },
    getSelectedRoom(state) {
      return state.selectedRoom;
    }
  }
});
